// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import Vuelidate from 'vuelidate'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/normalize.css'
import './assets/css/styles.css'
import './assets/css/admin.css'
import 'bootstrap/dist/js/bootstrap.js'
import store from './store/index.js'
import VueGraph from 'vue-graph'
import VueHighlightJS from 'vue-highlightjs'

Vue.config.productionTip = false
// Object.definePrototype(Vue.prototype, '$localforge', { value: localforage })
// Vue.prototype.$localforage = localforage
Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(Vuelidate)
Vue.use(VueGraph)
Vue.use(VueHighlightJS)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App :maps-loaded="ismapsloaded" />',
  components: { App },
  data: {
    ismapsloaded: false,
    isCaptchaLoaded: false
  },
  created () {
    const me = this
    const googleMapScript = `https://maps.googleapis.com/maps/api/js?key=AIzaSyB97rbzptD66j45uBeXnI_egde3I9kyqOI&libraries=places&callback=initMap`
    const googleRecaptchaScript = `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit`

    let script = document.createElement('script')
    script.src = googleMapScript
    script.type = 'text/javascript'
    document.body.appendChild(script)
    let scriptCaptcha = document.createElement('script')
    scriptCaptcha.src = googleRecaptchaScript
    document.body.appendChild(scriptCaptcha)
    window.initMap = () => {
      me.ismapsloaded = true
    }
    window.vueRecaptchaApiLoaded = () => {
      console.log('vueRecaptchaApiLoaded')
      me.isCaptchaLoaded = true
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js